import axios from "axios";


export default {
    getKeyCountry(){
        return axios.get("/a1/country")
    }
}